import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { dispatch } from '@rematch/core';
class NewCard extends Component {
  state = { modalOpen: true }

  updateField = (field, value) => {
    this.setState({ [field]: value })
  }

  handleAdd = () => {
    this.props.onAdd(this.state)
  }
  componentWillMount() {
    dispatch.lifeCycle.showResourecePane(null)
    dispatch.createPack.addActivityModalOpen(true);
  }

  render() {
    return (
      <div >
      </div>
    )
  }
}

NewCard.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired
}
NewCard.defaultProps = {}

export default NewCard
